import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "jumbo" }
const _hoisted_2 = { class: "gauche" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "marge" }, null, -1)
const _hoisted_4 = { class: "contenu" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", null, "Répertoire agroalimentaire Chaudière-Appalaches", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, "Bienvenue!", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Ce répertoire est la référence pour la région qui vous permettra de trouver des producteurs (trices), transformateurs (trices) du domaine agroalimentaire en Chaudière-Appalaches. Vous pouvez effectuer des recherches très précises selon vos besoins (type de conservation, certification, etc.) ou simplement par nom de produit. Vous pourrez, par la suite, entrer en contact avec les entreprises afin de tisser des liens d’affaires. Il est construit pour favoriser le commerce entre les entreprises. Pour les besoins personnels, nous vous invitons à visiter d’autres sites comme : "),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://www.taca.qc.ca/fr/les-arrets-gourmands/decouvrir-les-arrets-gourmands/"
  }, "Les Arrêts Gourmands de la Chaudière-Appalaches"),
  /*#__PURE__*/_createTextVNode(" ou "),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://mangeonslocal.upa.qc.ca/explorer"
  }, "Mangeons local de UPA.")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, "Comment ça marche ?", -1)
const _hoisted_9 = { class: "button-video-icon" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, " Utilisez la barre de recherche ou les filtres pour commencer votre recherche. ")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "droite" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "contenu" }),
  /*#__PURE__*/_createElementVNode("div", { class: "marge" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Nav = _resolveComponent("Nav")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ModalVideo = _resolveComponent("ModalVideo")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createVNode(_component_Nav),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("button", {
            class: "button-video",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal = true))
          }, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_font_awesome_icon, { icon: ['fa', 'circle-play'] })
            ])
          ]),
          (_ctx.showModal)
            ? (_openBlock(), _createBlock(_component_ModalVideo, {
                key: 0,
                onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModal = false))
              }))
            : _createCommentVNode("", true),
          _hoisted_10
        ])
      ]),
      _hoisted_11
    ], 512), [
      [_vShow, this.$route.meta.cacheJumbotron === false]
    ])
  ]))
}